module.exports = __webpack_public_path__ + "static/media/lettering-title.ed1b9dca.png";